exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{background-color:#fff}.image{height:270px;background-position:center;background-size:cover}a{text-decoration:none}", ""]);

// exports
